export default "__VITE_ASSET__4ByOSv84__"